import { Link } from "react-router-dom";
import { ChevronRight, Layers } from "lucide-react";
import { useSettings } from "../shared";
import { CMS_CATALOG, CmsLogo, StatusBadge, cmsStatus } from "./catalog";

// Grid of every supported CMS; each card opens its integration guide.
export default function CmsListSection() {
  const { cmsConn, loading } = useSettings();

  return (
    <div className="space-y-4" data-testid="cms-list">
      <div className="flex items-start gap-2">
        <Layers size={14} strokeWidth={2} className="text-zinc-900 mt-0.5" />
        <div>
          <p className="text-sm font-bold text-zinc-900">Supported CMS</p>
          <p className="text-[11px] text-zinc-500">
            Each organization syncs from one CMS. Pick one to see how to connect it.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {CMS_CATALOG.map(cms => {
          const status = cmsStatus(cms, cmsConn);
          return (
            <Link
              key={cms.id} to={cms.id}
              data-testid={`cms-card-${cms.id}`}
              className="group bg-white rounded-xl border border-zinc-100 shadow-sm p-5 flex flex-col gap-3 hover:border-zinc-300 hover:shadow transition-all"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3">
                  <CmsLogo cms={cms} />
                  <div>
                    <p className="text-sm font-bold text-zinc-900">{cms.name}</p>
                    <p className="text-[10px] text-zinc-400">{cms.via}</p>
                  </div>
                </div>
                {!loading && <StatusBadge status={status} />}
              </div>
              <p className="text-xs text-zinc-500 leading-relaxed flex-1">{cms.tagline}</p>
              <span className="inline-flex items-center gap-1 text-[11px] font-bold text-zinc-900 group-hover:gap-1.5 transition-all">
                {status.key === "none" ? "Setup guide" : "Manage"} <ChevronRight size={12} />
              </span>
            </Link>
          );
        })}
      </div>

      <p className="text-[10px] text-zinc-400">
        Using a different CMS? Everything after sync works the same for any source — tell us which one you need.
      </p>
    </div>
  );
}
